'use strict'

import AlertTemplate from './template/AlertTemplate.vue'

const AlertModule = {
  install (Vue) {
    var AlertConstructor = Vue.extend(AlertTemplate)
    var alertInstance = null

    var setAlertInstance = function (message, isConfirm, isSelect, isHideCancel, btnA, btnB, btnC, isGray) {
      if (alertInstance) {
        alertInstance.isShowModal = true
        alertInstance.isConfirm = isConfirm
        alertInstance.isSelect = isSelect
        alertInstance.isHideCancel = isHideCancel
        alertInstance.btnA = btnA
        alertInstance.btnB = btnB
        alertInstance.btnC = btnC
        alertInstance.isGray = isGray
        alertInstance.message = message
        return
      }

      alertInstance = new AlertConstructor({
        el: document.createElement('div'),
        data () {
          return {
            message: message,
            isConfirm: isConfirm,
            isSelect: isSelect,
            isHideCancel: isHideCancel,
            btnA: btnA,
            btnB: btnB,
            btnC: btnC,
            isGray: isGray
          }
        }
      })
    }

    const Alert = {
      alert: async function (message) {
        return new Promise((resolve) => {
          setAlertInstance(message, false, false, true, '', '')
          alertInstance.isShowModal = true
          alertInstance.callback = function () {
            resolve()
          }
          document.body.appendChild(alertInstance.$el)
          alertInstance.open()
        })
      },

      customAlert: async function (message, isHideCancel, btnA) {
        // true false로 변환
        isHideCancel = !!isHideCancel
        return new Promise((resolve) => {
          setAlertInstance(message, false, false, isHideCancel, btnA, '')
          alertInstance.isShowModal = true
          alertInstance.callback = function () {
            resolve()
          }
          document.body.appendChild(alertInstance.$el)
          alertInstance.open()
        })
      },
      
      customGrayAlert: async function (message, isHideCancel, btnA, isGray) {
        // true false로 변환
        isHideCancel = !!isHideCancel
        console.log(isGray)
        return new Promise((resolve) => {
          setAlertInstance(message, false, false, isHideCancel, btnA, '', '',isGray)
          alertInstance.isShowModal = true
          alertInstance.callback = function () {
            resolve()
          }
          document.body.appendChild(alertInstance.$el)
          alertInstance.open()
        })
      },

      confirm: async function (message) {
        return new Promise((resolve) => {
          setAlertInstance(message, true, false, true, '', '')
          alertInstance.isShowModal = true
          alertInstance.callback = function (result) {
            if (result == true) {
              resolve(true)
            } else {
              resolve(false)
            }
          }
          document.body.appendChild(alertInstance.$el)
          alertInstance.open()
        })
      },
      select: async function (message, btnA, btnB) {
        return new Promise((resolve) => {
          setAlertInstance(message, false, true, true, btnA, btnB)
          alertInstance.isShowModal = true
          alertInstance.open()
          alertInstance.callback = function (result) {
            resolve(result)
          }
          document.body.appendChild(alertInstance.$el)
        })
      },
      customSelect: async function (message, isHideCancel, btnA, btnB) {
        isHideCancel = !!isHideCancel
        return new Promise((resolve) => {
          setAlertInstance(message, false, true, isHideCancel, btnA, btnB)
          alertInstance.isShowModal = true
          alertInstance.callback = function (result) {
            resolve(result)
          }
          document.body.appendChild(alertInstance.$el)
          alertInstance.open()
        })
      },
      close: function () {
        if (alertInstance) {
          alertInstance.closed()
          alertInstance.isShowModal = false
          return
        }
      }
    }

    window.$Alert = Alert
    Vue.Alert = Alert
    Vue.prototype.$Alert = Alert
  }
}

export default AlertModule



// WEBPACK FOOTER //
// ./src/modules/alert.js